var Indicator = (function () {
  /**
   * 计算obv指标
   *
   * @method OBV
   * @param {Array} ticks
   * ticks为二维数组类型，其中内层数组第一个值为收盘价，第二个值为成交量
   * @return {Array} obvs
   */
  var obv = function (ticks) {
    var lastTick, obvs = [], length = ticks.length;
    for(var i = 0; i < length; i++) {
      var value = 0, curTick = ticks[i];
      if(i != 0) {
        var lastObvValue = obvs[i - 1];
        if(curTick[0] >= lastTick[0]) {
          value = lastObvValue + curTick[1];
        } else {
          value = lastObvValue - curTick[1];
        }
      }
      obvs.push(value);
      lastTick = curTick;
    }
    return obvs;
  };


  const calcEMA = function (n, data, field) {
    var i, l, ema, a;
    a = 2 / (n + 1);
    if(field) {
      ema = [data[0][field]];
      for(i = 1, l = data.length; i < l; i++) {
        ema.push((a * data[i][field] + (1 - a) * ema[i - 1]).toFixed(3));
      }
    } else {
      ema = [data[0]];
      for(i = 1, l = data.length; i < l; i++) {
        ema.push((a * data[i] + (1 - a) * ema[i - 1]).toFixed(3));
      }
    }
    return ema;
  };

  const calcDIF = function (short, long, data, field) {
    var i, l, dif, emaShort, emaLong;
    dif = [];
    emaShort = calcEMA(short, data, field);
    emaLong = calcEMA(long, data, field);
    for(i = 0, l = data.length; i < l; i++) {
      dif.push(emaShort[i] - emaLong[i])
    }
    return dif;
  };

  const calcDEA = function (mid, dif) {
    return calcEMA(mid, dif);
  };

  /*
   * 计算MACD
   * @param {number} short 快速EMA时间窗口
   * @param {number} long 慢速EMA时间窗口
   * @param {number} mid dea时间窗口
   * @param {array} data 输入数据
   * @param {string} field 计算字段配置
   */
  const calcMACD = function (short, long, mid, data, field) {
    var i, l, dif, dea, macd, result;
    result = {};
    macd = [];
    dif = calcDIF(short, long, data, field);
    dea = calcDEA(mid, dif);
    for(i = 0, l = data.length; i < l; i++) {
      macd.push((dif[i] - dea[i]) * 2)
    }
    result.dif = dif.map(item => Number(item))
    result.dea = dea.map(item => Number(item))
    result.macd = macd.map(item => Number(item))
    return result
  }

  var getMaxHighAndMinLow = function (ticks) {
    var maxHigh = ticks[0][3], minLow = ticks[0][2];
    for(var i = 0; i < ticks.length; i++) {
      var t = ticks[i], high = t[3], low = t[2];
      if(high > maxHigh) {
        maxHigh = high;
      }
      if(low < minLow) {
        minLow = low;
      }
    }
    return [maxHigh, minLow];
  };

  /**
   *
   * 计算kdj指标,rsv的周期为9日
   *
   * @method KDJ
   * @param {Array} ticks
   * 二维数组类型，其中内层数组包含三个元素值，第一个值表示当前Tick的最高价格，第二个表示当前Tick的最低价格，第三个表示当前Tick的收盘价格
   * @return {Object} 返回一个包含k d j属性的对象,每个属性对应的类型为{Array[Number]}
   */
  var kdj = function (ticks) {
    var nineDaysTicks = [], days = 9, rsvs = [];
    var ks = [], ds = [], js = [];
    var lastK, lastD, curK, curD;
    var maxAndMin, max, min;
    for(var i = 0; i < ticks.length; i++) {
      var t = ticks[i], close = t[1];
      nineDaysTicks.push(t);
      maxAndMin = getMaxHighAndMinLow(nineDaysTicks);
      max = maxAndMin[0];
      min = maxAndMin[1];
      if(max == min) {
        rsvs.push(0);
      } else {
        rsvs.push((close - min) / (max - min) * 100);
      }
      if(nineDaysTicks.length == days) {
        nineDaysTicks.shift();
      }
      if(i == 0) {
        lastK = lastD = rsvs[i];
      }
      curK = 2 / 3 * lastK + 1 / 3 * rsvs[i];
      ks.push(curK);
      lastK = curK;

      curD = 2 / 3 * lastD + 1 / 3 * curK;
      ds.push(curD);
      lastD = curD;

      js.push(3 * curK - 2 * curD);
    }
    return {"k": ks, "d": ds, "j": js};
  };

  /**
   *
   * 计算boll指标,ma的周期为20日
   *
   * @method BOLL
   * @param {Array} ticks
   * 一维数组类型，每个元素为当前Tick的收盘价格
   * @return {Object} 返回一个包含upper mid lower属性的对象,每个属性对应的类型为{Array[Number]}
   */
  var boll = function (ticks) {
    //移动平均线周期为20
    var maDays = 20, tickBegin = maDays - 1, maSum = 0, p = 0;
    var ups = [], mas = [], lows = [];
    for(var i = 0; i < ticks.length; i++) {
      var c = ticks[i], ma, md, bstart, mdSum;
      maSum += c;
      if(i >= tickBegin) {
        maSum = maSum - p;
        ma = maSum / maDays;
        mas.push(ma);
        bstart = i - tickBegin;
        p = ticks[bstart];
        mdSum = ticks.slice(bstart, bstart + maDays).reduce(function (a, b) {return a + Math.pow(b - ma, 2);}, 0);
        md = Math.sqrt(mdSum / maDays);
        ups.push(ma + 2 * md);
        lows.push(ma - 2 * md);
      } else {
        //ugly constant, just keep the same type for client
        ups.push('');
        mas.push('');
        lows.push('');
      }
    }
    return {"upper": ups, "mid": mas, "lower": lows};
  };

  /**
   *
   * 计算rsi指标,分别返回以6日，12日，24日为参考基期的RSI值
   *
   * @method RSI
   * @param {Array} ticks
   * 一维数组类型，每个元素为当前Tick的收盘价格
   * @return {Object} 返回一个包含rsi6 rsi12 rsi24属性的对象,每个属性对应的类型为{Array[Number]}
   */
  var rsi = function (ticks) {
    var lastClosePx = ticks[0];
    var days = [6, 12, 24], result = {};
    for(var i = 0; i < ticks.length; i++) {
      var c = ticks[i];
      var m = Math.max(c - lastClosePx, 0), a = Math.abs(c - lastClosePx);
      for(var di = 0; di < days.length; di++) {
        var d = days[di];
        if(!result.hasOwnProperty("rsi" + d)) {
          result["lastSm" + d] = result["lastSa" + d] = 0;
          result["rsi" + d] = [0];
        } else {
          result["lastSm" + d] = (m + (d - 1) * result["lastSm" + d]) / d;
          result["lastSa" + d] = (a + (d - 1) * result["lastSa" + d]) / d;
          if(result["lastSa" + d] != 0) {
            result["rsi" + d].push(result["lastSm" + d] / result["lastSa" + d] * 100);
          } else {
            result["rsi" + d].push(0);
          }
        }
      }
      lastClosePx = c;
    }
    days.forEach(key => {
      result["rsi" + key] = result["rsi" + key].map((item, index) => {
        if(index < key) item = ''
        return item
      })
    })
    return {"rsi6": result["rsi6"], "rsi12": result["rsi12"], "rsi24": result["rsi24"]};
  };

  const getMa = (data, dayCount) => {
    var result = []
    var sum = 0
    data[-1] = 0
    for(var i = 0, len = data.length; i < len; i++) {
      sum += data[i]
      if(i < dayCount - 1) {
        result.push('-')
      } else {
        sum -= data[i - dayCount]
        result.push(sum / dayCount)
      }
    }
    delete data[-1]
    return result
  }

  const biasCalc = function(ticks, days) {
    let ma = getMa(ticks, days)
    return ticks.map((c, index) => {
      if(index < days) return '-'
      return 100 * (c - ma[index]) / ma[index]
    })
  }

  const bias = function(ticks) {
    return [biasCalc(ticks, 6), biasCalc(ticks, 12), biasCalc(ticks, 24)]
  }

  const getTyp = function (ticks) {
    return ticks.map(tick => (tick[1] + tick[2] + tick[3]) / 3)
  }

  const getAve = function(typ, typMA, days) {
    let res = []
    let sum = 0
    typ[-1] = 0
    typMA[-1] = 0
    for(let i = 0; i < typ.length; ++i) {
      if(i < days - 1) {
        res.push('-')
        continue
      }
      let sum = 0
      for(let j = 0; j < days; ++j) {
        sum += Math.abs(typ[i - j] - typMA[i])
      }
      res.push(sum / days)
    }
    delete typ[-1]
    delete typMA[-1]
    return res
  }

  const cci = function(ticks) {
    let typ = getTyp(ticks)
    let typMA = getMa(typ, 14)
    let ave = getAve(typ, typMA, 14)
    let res = []
    ticks.forEach((item, index) => {
      if(index < 13) return res.push('-')
      let t = (typ[index] - typMA[index]) / ave[index] / 0.015
      res.push(t)
    })
    return res
  }

  // const getHighAndLow = function(ticks, days) {

  //   ticks.forEach(item => {

  //   })
  //   return {
  //     H,
  //     L
  //   }
  // }

  const calcWr = function(ticks, days) {
    let {H, L} = getMaxHighAndMinLow
    return ticks.map((item, index) => 100 * (H[index] - item[1]) / (H[index] - L[index]))
  }

  const wr = function(ticks) {
    return [calcWr(ticks, 6), calcWr(ticks, 10)]
  }

  return {
    "OBV": obv,
    "MACD": calcMACD,
    "KDJ": kdj,
    "BOLL": boll,
    "RSI": rsi,
    'BIAS': bias,
    'CCI': cci,
    'WR': wr
  };
})();

export default Indicator
